<template>
  <div class="skill">
    <div>
      <base-icon :icon="icon" :height="2" :width="2" ></base-icon>
      <p class="my-auto">{{title}}</p>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/BaseIcon";
export default {
  name: "SkillItem",
  components: {BaseIcon},
  props: ['icon', 'title']
}
</script>

<style scoped>
.skill {
  padding: .5rem 0;
  border-radius: 10px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

}

.skill div {
  display: flex;
  align-items: center;
}

p {
  color: #000000;
  margin-left: .3rem;
  text-transform: capitalize;
}

.skill:hover {
  background-color: #F5D6D3;
  background-blend-mode: lighten;

}

</style>